import React from 'react';

import './footer.css';

export default function Footer() {
    return (
        <footer className="footer-brothertec">
            <div className="container">
                <span className="footer-brothertec-text">
                    BrotherTec © 2020. Todos os direitos reservados.
                </span>
            </div>
        </footer>
    );
}